export { default } from './EnNavigationArea.vue';
export { default as EnNavigationArea } from './EnNavigationArea.vue';
